

import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

import vSelect from "vue-select"
import TextAreaExpand from "../Fields/TextAreaExpand.vue"
import DataSourceSelect from "../Fields/DataSourceSelect.vue"
import DataSourceTemplate from "../Fields/DataSourceTemplate.vue"
import DateTime from "../Fields/DateTime.vue"
import Tags from "../Fields/Tags.vue"
import Numeric from "../Fields/Numeric.vue"
import UserRoleComponent from "./Users/UserRole.vue"
import FormGroup from "../Fields/FormGroup.vue"
import ExternalLink from "../Fields/ExternalLink.vue"
import UniqueCaseNumber from "../Fields/CaseNumber.vue"

import CaseFileUpload from "./Files/CaseFileUpload.vue"
import CaseFileDisplay from "./Files/CaseFileDisplay.vue"
import DataDetailsModal from "@/components/CaseDetails/DataDetailsModal.vue"
import MapLocation from "@/components/Fields/MapLocation.vue"
import CaseSearch from "@/components/CaseDetails/CaseSearch.vue"
import MergeField from "@/components/CaseDetails/MergeField.vue"
import UserImage from "@/components/UserImage.vue"
import Confirmation from "../Confirmation.vue"

import { CaseDetails } from "@/types"
import { CaseUser, UserRole } from "@/types/caseUser"

import { CaseSelection, FieldSelection, FieldType, MergeFieldOption, FieldDisplay, MergeCaseFields } from "@/types/mergeFieldTypes"
import fieldDisplayMapping from "@/services/fieldDisplayMapping"

import _ from "lodash"

import User from "@/types/user"

import api from "@/services/api"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"
import CaseFile from "@/types/caseFile"
const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect,
		"text-area-expand": TextAreaExpand,
		"file-upload": CaseFileUpload,
		"case-file": CaseFileDisplay,
		"data-select": DataSourceSelect,
		"data-template": DataSourceTemplate,
		"tags": Tags,
		"data-details": DataDetailsModal,
		"form-group": FormGroup,
		"numeric": Numeric,
		"date-time": DateTime,
		"map-location": MapLocation,
		"user-role": UserRoleComponent,
		"external-link": ExternalLink,
		"case-number": UniqueCaseNumber,
		"case-search": CaseSearch,
		"merge-field": MergeField,
		"scrollbar": VuePerfectScrollbar,
		"user-image": UserImage,
		"confirm": Confirmation
	}
})
export default class CaseMergeModal extends Vue {
	$refs!: {
		caseMergeModal: BModal;
		confirmModal: Confirmation;
		caseSearch: CaseSearch;
	}

	@Prop({ type: Boolean, default: false })
	public value!: boolean

	@Prop()
	public currentCase!: CaseDetails;

	@Getter("getMe")
	public me!: User;

	@Prop({ default: () => [] })
	public caseFiles!: CaseFile[];

	public searchCaseFiles: CaseFile[] = [];

	public searchCaseDetails: CaseDetails | null = null;

	public selectedFields: {[key: string]: FieldSelection; } = {};
	private caseFieldMatches: { [key:string]: MergeFieldOption } = {}

	public get seachCaseNumber (): string {
		return (this.searchCaseDetails && this.searchCaseDetails.caseNumber) || "0"
	}
	public open () {
		this.$refs.caseMergeModal.show()
		// reset search
		this.searchCaseDetails = null
		this.selectedFields = {}
	}

	public calculateCaseFieldMatches (): { [key:string]: MergeFieldOption } {
		if (!this.currentCase || !this.currentCase.fields) {
			this.selectedFields = {}
			return {}
		}
		if (!this.searchCaseDetails || !this.searchCaseDetails.fields) {
			this.selectedFields = {}
			return {}
		}

		if (!this.searchCaseDetails.id || !this.currentCase.id) {
			throw Error("Missing Case ID")
		}

		let results: { [key:string]: MergeFieldOption} = {}

		let globalFromColumns = fieldDisplayMapping.getGlobalDisplayFields(this.currentCase, this.caseFiles)
		let globalToColumns = fieldDisplayMapping.getGlobalDisplayFields(this.searchCaseDetails, this.searchCaseFiles)

		let uniqueFields = _.chain(globalFromColumns.map(c => c.id).concat(globalToColumns.map(c => c.id)))
			.uniq()
			.value()

		for (let i = 0; i < uniqueFields.length; i++) {
			let uniqueField = uniqueFields[i]
			let globalFromColumn = globalFromColumns.find(c => c.id === uniqueField) || null
			let globalToColumn = globalToColumns.find(c => c.id === uniqueField) || null

			results[uniqueField] = Vue.observable({
				fromField: globalFromColumn,
				toField: globalToColumn,
				fromCaseId: this.currentCase.id,
				toCaseId: this.searchCaseDetails.id,
				selectedCase: CaseSelection.fromCase,
				fieldType: FieldType.global
			})
		}

		let currentCaseFields = fieldDisplayMapping.getDisplayFields(this.currentCase, this.caseFiles, this.me)
		for (let i = 0; i < currentCaseFields.length; i++) {
			let currentCaseField = currentCaseFields[i]

			let fieldId = currentCaseField.id

			results[fieldId] = Vue.observable({
				fromField: currentCaseField,
				toField: null,
				fromCaseId: this.currentCase.id,
				toCaseId: null,
				selectedCase: CaseSelection.fromCase,
				fieldType: FieldType.regular
			})

			if (!this.currentCase.id) {
				throw new Error("No case ID on current record found")
			}
		}

		let searchCaseFields = fieldDisplayMapping.getDisplayFields(this.searchCaseDetails, this.searchCaseFiles, this.me)
		for (let i = 0; i < searchCaseFields.length; i++) {
			let searchCaseField = searchCaseFields[i]

			let fieldId = searchCaseField.id

			if (fieldId in results) {
				results[fieldId].toField = searchCaseField
				results[fieldId].toCaseId = this.searchCaseDetails.id
			} else {
				results[fieldId] = Vue.observable({
					fromField: null,
					toField: searchCaseField,
					fromCaseId: this.currentCase.id,
					toCaseId: this.searchCaseDetails.id,
					selectedCase: CaseSelection.toCase,
					fieldType: FieldType.regular
				})
			}
		}

		// set default selected fields
		for (let fieldId in results) {
			if (fieldId in this.selectedFields) {
				// is already selected
				results[fieldId].selectedCase = this.selectedFields[fieldId].caseSelection
			} else {
				let selectedCase: FieldSelection = Vue.observable({
					caseSelection: this.getDefaultCaseSelection(results[fieldId]),
					fieldType: this.eitherField(results[fieldId]).fieldType,
					fieldId: fieldId
				})

				results[fieldId].selectedCase = selectedCase.caseSelection
				this.$set(this.selectedFields, fieldId, selectedCase)
			}
		}

		return results
	}

	private getDefaultCaseSelection (mergeFieldOption: MergeFieldOption) : CaseSelection {
		let field = this.eitherField(mergeFieldOption)
		let isMergeType = this.isMergeField(field)
		if (isMergeType) {
			return CaseSelection.merge
		}

		// if there's a To field with a value, take this value, including if the value is false
		if (mergeFieldOption.toField &&
			mergeFieldOption.toField.value !== null &&
			mergeFieldOption.toField.value !== undefined) {
			return CaseSelection.toCase
		}

		// if there's not a To field with a value, but there's a From field with a value, take From field value
		if (mergeFieldOption.fromField &&
			mergeFieldOption.fromField.value !== null &&
			mergeFieldOption.fromField.value !== undefined) {
			return CaseSelection.fromCase
		}

		// Otherwise if null entries for To field and From field, default to To field
		return CaseSelection.toCase
	}

	private isMergeDataType (dataType: string):boolean {
		return dataType === "list-data" ||
			dataType === "list-multiple" ||
			dataType === "user-role"
	}

	private isMergeField (fieldDisplay: FieldDisplay):boolean {
		return this.isMergeDataType(fieldDisplay.dataType)
	}

	private title (caseMatch: MergeFieldOption) {
		let field = (caseMatch.fromField || caseMatch.toField)!
		return field.title
	}

	private hasViewPermission (caseFieldMatch: MergeFieldOption): boolean {
		let field = (caseFieldMatch.fromField || caseFieldMatch.toField)!
		return field.hasViewPermission
	}

	public async fillSearchFields (caseNumber: string | null) {
		if (!caseNumber) {
			this.searchCaseDetails = null
			this.selectedFields = {}
			return
		}

		this.searchCaseDetails = await api.caseDetails(caseNumber)
		this.searchCaseFiles = await api.caseFiles(this.searchCaseDetails.id!)

		this.caseFieldMatches = this.calculateCaseFieldMatches()
	}

	public selectCase (selectedFieldId: string, caseSelection: CaseSelection) {
		this.$set(this.selectedFields[selectedFieldId], "caseSelection", caseSelection)
		this.caseFieldMatches[selectedFieldId].selectedCase = this.selectedFields[selectedFieldId].caseSelection
	}

	private userRoleHasSubRoles (caseFieldMatch: MergeFieldOption) : boolean {
		return (caseFieldMatch.fromField &&
		caseFieldMatch.fromField.value &&
		caseFieldMatch.fromField.value.subRoles &&
		caseFieldMatch.fromField.value.subRoles.length > 0) ||
		(caseFieldMatch.toField &&
		caseFieldMatch.toField.value &&
		caseFieldMatch.toField.value.subRoles &&
		caseFieldMatch.toField.value.subRoles.length > 0)
	}

	private userRoleHasUsers (caseFieldMatch: MergeFieldOption) : boolean {
		return (caseFieldMatch.fromField &&
		caseFieldMatch.fromField.value &&
		caseFieldMatch.fromField.value.users &&
		caseFieldMatch.fromField.value.users.length > 0) ||
		(caseFieldMatch.toField &&
		caseFieldMatch.toField.value &&
		caseFieldMatch.toField.value.users &&
		caseFieldMatch.toField.value.users.length > 0)
	}

	private getMergedSubRoles (caseFieldMatch: MergeFieldOption) : UserRole[] {
		let fromSubRoles: UserRole[] = (caseFieldMatch.fromField && caseFieldMatch.fromField.value && caseFieldMatch.fromField.value.subRoles) || []
		let toSubRoles: UserRole[] = (caseFieldMatch.toField && caseFieldMatch.toField.value && caseFieldMatch.toField.value.subRoles) || []

		let allSubRoles = fromSubRoles.concat(toSubRoles)
		let mergedSubRoles: UserRole[] = _.chain(allSubRoles)
			.groupBy("title")
			.map((value, key) => ({
				title: key,
				users: _.chain(value.map(c => c.users || [])).flatten().uniqBy("id").value(),
				subRoles: [] }))
			.value()

		return mergedSubRoles
	}

	private getMergedUsers (caseFieldMatch: MergeFieldOption) : CaseUser[] {
		let fromUsers: CaseUser[] = (caseFieldMatch.fromField && caseFieldMatch.fromField.value && caseFieldMatch.fromField.value.users) || []
		let toUsers: CaseUser[] = (caseFieldMatch.toField && caseFieldMatch.toField.value && caseFieldMatch.toField.value.users) || []
		return _.uniqBy(fromUsers.concat(toUsers), "id")
	}

	private getMergedListUsers (caseFieldMatch: MergeFieldOption) : any[] {
		let fromUsers = (caseFieldMatch.fromField && caseFieldMatch.fromField.value) || []
		let toUsers = (caseFieldMatch.toField && caseFieldMatch.toField.value) || []

		return _.uniqBy(fromUsers.concat(toUsers), "id")
	}

	private getCaseUser (userId: string) : CaseUser {
		let currentCaseUser = this.currentCase.users.find((u: CaseUser) => u.id === userId.toString())
		if (!currentCaseUser) {
			let searchCaseUser = this.searchCaseDetails!.users.find((u: CaseUser) => u.id === userId.toString())
			if (!searchCaseUser) {
				throw Error("User not found")
			}
			return searchCaseUser
		}
		return currentCaseUser
	}

	private getListDataString (caseFieldMatch: MergeFieldOption) : string {
		let allItems = ((caseFieldMatch.fromField && caseFieldMatch.fromField.value) || [])
			.concat((caseFieldMatch.toField && caseFieldMatch.toField.value) || [])

		if (allItems.length > 0) {
			return `${allItems.length} Data Objects(s)`
		}
		return ""
	}

	private getMergedListString (caseFieldMatch: MergeFieldOption) : string {
		let allItems = ((caseFieldMatch.fromField && caseFieldMatch.fromField.value) || [])
			.concat((caseFieldMatch.toField && caseFieldMatch.toField.value) || [])

		let results = _.chain(allItems)
			.uniqBy(c => c.id || c.label)
			.sortBy(c => c.label)
			.map(c => c.label)
			.value()
			.join(", ")

		return results
	}

	private eitherField (caseFieldMatch: MergeFieldOption) : FieldDisplay {
		return (caseFieldMatch.fromField || caseFieldMatch.toField)!
	}

	private async ok () {
		this.$refs.confirmModal.open(this.searchCaseDetails!.caseNumber!, async () => {
			let model: MergeCaseFields = {
				fieldSelections: Object.keys(this.selectedFields).map(key => this.selectedFields[key])
			}

			await api.mergeCases(this.currentCase!.id!, this.searchCaseDetails!.id!, model).then(() => {
				this.$router.push({ path: `/cases/${this.searchCaseDetails!.caseNumber}` })
			})
		})
	}

	private get disableMerge () : boolean {
		return this.searchCaseDetails == null && Object.keys(this.selectedFields).length === 0
	}

	// Enum template support
	CaseSelection: any = CaseSelection;

	private modalClosing () {
		// Clear out matches on modal close
		this.caseFieldMatches = {}
	}
}
